import { render, staticRenderFns } from "./PropertyHasMortgageYN.vue?vue&type=template&id=1ecf25b7"
import script from "./PropertyHasMortgageYN.vue?vue&type=script&lang=js"
export * from "./PropertyHasMortgageYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports